import { useEffect, useState } from "react";
import { Title } from "./base/Title";
import {
  BaseQuestion,
  YesOrNoQuestion,
  InputNumberQuestion,
  InputQuestion,
  ScoredAnswerQuestion,
  ScoredAnswerQuestion1,
  ScoredAnswerQuestion2,
  CheckboxAnswerQuestion,
  RadioGroupAnswerQuestion,
  TableQuestion
} from "./base/BaseQuestion";


import { StepButton } from "./step-button";
import { Form } from "antd";
export const Section1 = ({
  title,
  handleSubmit,
  handleFail,
  currentStep,
  flowStepsLenght,
}) => {
  const majorIndex = 1;

  const [nextStep, setNextStep] = useState();
  const [isUsedMRT, setUsedMRT] = useState(false);
  const [isUsedMRT0, setUsedMRT0] = useState(false);
  const [isWitchMetro, setWitchMetro] = useState(false);
  const [isWitchMetro1, setWitchMetro1] = useState(false);

  return (
    <div className="text-left w-full" style={{ textAlign: "justify" }}>
      <Title index={majorIndex} content={title} />

      <Form
        onFinish={(value) => handleSubmit(value, nextStep)}
        onFinishFailed={handleFail}
      >
        <YesOrNoQuestion
          majorIndex={majorIndex}
          mirrorIndex={1}
          question="Anh/Chị đã từng di chuyển bằng các tuyến metro của Thành phố Hà Nội chưa?"
          rawQuestion="Anh/Chị đã từng di chuyển bằng các tuyến metro của Thành phố Hà Nội chưa?"
          yesAnswer="Đã từng"
          noAnswer="Chưa từng"
          onChange={(value) => {
            console.log("Giá trị đã chọn:", value);
            setUsedMRT0(value === "Đã từng");
          }}
        />

        <p>
          Trước khi được đưa vào vận hành thương mại chính thức, các tuyến metro tại Thành phố Hà Nội đã tổ chức cho người dân <b>trải nghiệm</b> trong thời gian <b>15 ngày khai thác miễn phí</b>. Trong đó, tuyến đầu tiên, <b>Cát Linh - Hà Đông
          </b> khai thác miễn phí trong thời gian từ <b>06/11-20/11/2021</b>, và tuyến thứ hai, <b>Nhổn - Ga Hà Nội</b> từ ngày <b>08/8-22/8/2024</b>.
        </p>

        {isUsedMRT0 && (
          <>

 
            <YesOrNoQuestion
              majorIndex={majorIndex}
              mirrorIndex={2}
              question="Trong thời gian này, rất nhiều người dân Hà Nội đã tới tham trải nghiệm loại hình di chuyển mới này của Thủ đô. Anh/Chị đã từng tham gia trải nghiệm metro trong thời gian nêu trên hay không?"
              rawQuestion="Anh/Chị đã từng di chuyển bằng các tuyến metro của Thành phố Hà Nội chưa?"
              yesAnswer="Đã từng"
              noAnswer="Chưa từng"
              onChange={(value) => {
                console.log("Giá trị đã chọn:", value);
                setUsedMRT(value === "Đã từng");
              }}
            />

            {!isUsedMRT && (
              <div>
                <YesOrNoQuestion
                  majorIndex={majorIndex}
                  mirrorIndex={3}
                  question="Hiện nay, Anh/Chị có phải là người dùng thường xuyên (tần suất sử dụng trên 4 ngày/tuần) của metro không?"
                  rawQuestion="Hiện nay, Anh/Chị có phải là người dùng thường xuyên (tần suất sử dụng trên 4 ngày/tuần) của metro không?"
                  yesAnswer="Có"
                  noAnswer="Không"
                  onChange={(value) => {
                    setWitchMetro(value === "Có");
                  }}

                />
                {isWitchMetro && (
                  <RadioGroupAnswerQuestion
                    majorIndex={majorIndex}
                    mirrorIndex={undefined}
                    showType={"row"}
                    question={"Nếu có, đó là tuyến metro nào?"}
                    rawQuestion={"Nếu có, đó là tuyến metro nào?"}
                    answers={[
                      "Cát Linh – Hà Đông ",
                      "Nhổn – Ga Hà Nội ",
                      "Cả hai",
                    ]}
                  />
                )}

              </div>
            )}
            {isUsedMRT && (
              <div>
                <table className="table-fixed border-collapse w-full text-center">
                  <thead>
                    <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">

                      <td className="border-x-[1px] border-dashed border-gray-500">
                        <img
                          src={require("../assets/images/1.jpg")}
                          width="80%"
                          height={"80%"}
                          className="rounded-lg mx-auto my-1"
                        ></img>
                      </td>
                      <td className="border-x-[1px] border-dashed border-gray-500">
                        <img
                          src={require("../assets/images/2.jpg")}
                          width="80%"
                          height={"80%"}
                          className="rounded-lg mx-auto my-1"
                        ></img>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="text-center italic">
                  Khoảng <b>350.000</b> hành khách đã tham gia xếp hàng, trải nghiệm tuyến đường sắt Cắt Linh – Hà Đông trong 15 ngày đầu khai thác miễn phí.
                </p>

                <RadioGroupAnswerQuestion
                  majorIndex={majorIndex}
                  mirrorIndex={3}
                  showType={"row"}

                  question={"Anh/Chị tham gia thời gian 15 ngày khai thác miễn phí của tuyến metro nào?"}
                  rawQuestion={"Anh/Chị tham gia thời gian 15 ngày khai thác miễn phí của tuyến metro nào?"}
                  answers={[
                    "Cát Linh – Hà Đông ",
                    "Nhổn – Ga Hà Nội ",
                    "Cả hai",
                  ]}
                />




                <RadioGroupAnswerQuestion
                  majorIndex={majorIndex}
                  mirrorIndex={4}
                  showType={"row"}

                  question={"Anh/Chị vui lòng cho biết tần suất tham gia trải nghiệm trong thời gian 15 ngày khai thác miễn phí?"}
                  rawQuestion={"Anh/Chị vui lòng cho biết tần suất tham gia trải nghiệm trong thời gian 15 ngày khai thác miễn phí?"}
                  answers={[
                    "1-3 ngày ",
                    "4-6 ngày ",
                    "7-9 ngày ",
                    "10-12 ngày ",
                    "13-15 ngày ",
                  ]}
                />

                <table className="table-fixed border-collapse w-full text-center">
                  <thead>
                    <tr className="border-t-2 border-l-2 border-r-2 border-solid border-gray-500">
                    </tr>
                  </thead>
                  <tbody>
                    <tr className="border-b-2 border-l-2 border-r-2 border-solid border-gray-500">

                      <td className="border-x-[1px] border-dashed border-gray-500">
                        <img
                          src={require("../assets/images/3.jpg")}
                          width="80%"
                          height={"80%"}
                          className="rounded-lg mx-auto my-1"
                        ></img>
                      </td>
                      <td className="border-x-[1px] border-dashed border-gray-500">
                        <img
                          src={require("../assets/images/4.jpg")}
                          width="80%"
                          height={"80%"}
                          className="rounded-lg mx-auto my-1"
                        ></img>
                      </td>
                    </tr>
                  </tbody>
                </table>
                <p className="text-center italic">
                  Trong 15 ngày đầu khai thác miễn phí, tuyến Nhổn-Ga Hà Nội đã phục vụ khoảng <b>750.000</b> lượt hành khách tham gia trải nghiệm
                </p>
                <RadioGroupAnswerQuestion
                  majorIndex={majorIndex}
                  mirrorIndex={5}
                  showType={"column"}

                  question={"Tần suất số chuyến đi trung bình của Anh/Chị mỗi ngày trong thời gian 15 ngày khai thác miễn phí?"}
                  rawQuestion={"Tần suất số chuyến đi trung bình của Anh/Chị mỗi ngày trong thời gian 15 ngày khai thác miễn phí?"}
                  answers={[
                    "1-2 chuyến/ngày",
                    "Trên 2 chuyến/ngày",
                  ]}
                />

                <YesOrNoQuestion
                  majorIndex={majorIndex}
                  mirrorIndex={6}
                  question="Hiện nay, Anh/Chị có phải là người dùng thường xuyên (tần suất sử dụng trên 4 ngày/tuần) của metro không?"
                  rawQuestion="Hiện nay, Anh/Chị có phải là người dùng thường xuyên (tần suất sử dụng trên 4 ngày/tuần) của metro không?"
                  yesAnswer="Có"
                  noAnswer="Không"
                  onChange={(value) => {
                    setWitchMetro1(value === "Có");
                  }}
                />
                {isWitchMetro1 && (

                  <RadioGroupAnswerQuestion
                    majorIndex={majorIndex}
                    mirrorIndex={undefined}
                    showType={"row"}
                    question={"Nếu có, đó là tuyến metro nào?"}
                    rawQuestion={"Nếu có, đó là tuyến metro nào?"}
                    answers={[
                      "Cát Linh – Hà Đông ",
                      "Nhổn – Ga Hà Nội ",
                      "Cả hai",
                    ]}
                  />
                )}

              </div>
            )}
          </>
        )}

        <StepButton
          onStepChange={setNextStep}
          currentStep={currentStep}
          flowStepsLenght={flowStepsLenght}
        />
      </Form>

      <br />
      <br />
      <br />
    </div>
  );
};
